function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useRef } from 'react';
import Box from '../Box';
const FormGroupContext = /*#__PURE__*/React.createContext();
const {
  Provider
} = FormGroupContext;
const FormGroup = /*#__PURE__*/memo(_ref => {
  let {
    mb = 3,
    ...props
  } = _ref;
  const idRef = useRef(`form-group-${Math.floor(Math.random() * 10000000)}`);
  return /*#__PURE__*/React.createElement(Provider, {
    value: idRef.current
  }, /*#__PURE__*/React.createElement(Box, _extends({
    mb: mb
  }, props)));
});
FormGroup.propTypes = {};
FormGroup.displayName = 'FormGroup';
export default FormGroup;
export { FormGroupContext };